import { useMemo, useState } from "react";
import { Link, useOutletContext, useSearchParams } from "react-router-dom";

import PuertaCerrada from "../components/funcionales/PuertaCerrada";
import QrLlave from "../components/llaves/QrLlave";
import { seccion } from "../components/layout/secciones";
import { useRealtime } from "../services/store";
import { urlLlave } from "../shared/llaves";
import Loading from "./Loading";
import "./css/llaves.css";

/* LAS ETIQUETAS CON EL QR DE CADA LLAVE (ticket 522), para imprimir y pegar
 * en el llavero. Una por tractor activo, con el interno grande y la patente:
 * el QR es para el celular, el número es para la persona que busca la llave
 * en el tablero.
 *
 * Sin filtro salen todas; escribiendo internos («1004, 723») salen sólo ésas,
 * que es lo que se usa cuando se pierde o se gasta una. El QR abre el chat de
 * Cepi en WhatsApp con «Llave del interno … - Patente …» ya escrito
 * (`urlLlave`, Igna 27/10: los que se llevan las llaves son los choferes, y
 * ellos no tienen usuario del hub). */

/* Los internos escritos, separados por coma, espacio o punto y coma. */
export const internosPedidos = (texto) =>
  String(texto || "")
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);

const LlavesEtiquetas = () => {
  const { permisos = null } = useOutletContext() || {};
  const permiso = seccion("llaves")?.permiso || "ver.porteria";
  const puede = permisos === null || [].concat(permiso).some((p) => permisos.includes(p));
  const activos = useRealtime("tractoresActivos");
  // `?i=1030` viene de «Imprimir» en la pantalla de una llave: sale sólo ésa.
  const [params] = useSearchParams();
  const [filtro, setFiltro] = useState(() => params.get("i") || "");

  const lista = useMemo(() => {
    const todos = [...(activos || [])].sort((a, b) =>
      String(a.id).localeCompare(String(b.id), "es", { numeric: true }),
    );
    const pedidos = internosPedidos(filtro);
    return pedidos.length ? todos.filter((t) => pedidos.includes(String(t.id))) : todos;
  }, [activos, filtro]);

  if (permisos !== null && !puede) return <PuertaCerrada />;
  if (!activos?.length) return <Loading />;

  return (
    <div className="docs llaves-etiquetas">
      <div className="vig-novig-cab llaves-noimprimir">
        <Link className="tk-chip" to="/llaves">
          Llaves
        </Link>
        <input
          className="vig-filtro"
          type="search"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          placeholder="Internos"
          aria-label="Internos a imprimir"
          autoComplete="off"
        />
        <button
          type="button"
          className="btn"
          disabled={lista.length === 0}
          onClick={() => window.print()}
        >
          Imprimir {lista.length}
        </button>
      </div>

      <div className="llaves-hoja">
        {lista.map((t) => (
          <div className="llave-etiqueta" key={t.id}>
            <QrLlave texto={urlLlave(t.id, t.dominio)} tamano={120} titulo={`Llave del ${t.id}`} />
            <div className="llave-etiqueta-txt">
              <b>{t.id}</b>
              {t.dominio && <span>{t.dominio}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LlavesEtiquetas;
